'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var getTime = require('./time');

var Retimer = /*#__PURE__*/function () {
  function Retimer(callback, timeout, args) {
    _classCallCheck(this, Retimer);

    var that = this;
    this._started = getTime();
    this._rescheduled = 0;
    this._scheduled = timeout;
    this._args = args;
    this._triggered = false;

    this._timerWrapper = function () {
      if (that._rescheduled > 0) {
        that._scheduled = that._rescheduled - (getTime() - that._started);

        that._schedule(that._scheduled);
      } else {
        that._triggered = true;
        callback.apply(null, that._args);
      }
    };

    this._timer = setTimeout(this._timerWrapper, timeout);
  }

  _createClass(Retimer, [{
    key: "reschedule",
    value: function reschedule(timeout) {
      if (!timeout) {
        timeout = this._scheduled;
      }

      var now = getTime();

      if (now + timeout - (this._started + this._scheduled) < 0) {
        clearTimeout(this._timer);

        this._schedule(timeout);
      } else if (!this._triggered) {
        this._started = now;
        this._rescheduled = timeout;
      } else {
        this._schedule(timeout);
      }
    }
  }, {
    key: "_schedule",
    value: function _schedule(timeout) {
      this._triggered = false;
      this._started = getTime();
      this._rescheduled = 0;
      this._scheduled = timeout;
      this._timer = setTimeout(this._timerWrapper, timeout);
    }
  }, {
    key: "clear",
    value: function clear() {
      clearTimeout(this._timer);
    }
  }]);

  return Retimer;
}();

function retimer() {
  if (typeof arguments[0] !== 'function') {
    throw new Error('callback needed');
  }

  if (typeof arguments[1] !== 'number') {
    throw new Error('timeout needed');
  }

  var args;

  if (arguments.length > 0) {
    args = new Array(arguments.length - 2);
    /* eslint-disable no-var */

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 2];
    }
  }

  return new Retimer(arguments[0], arguments[1], args);
}

module.exports = retimer;